 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		27: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		27: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + chunkId + ".build." + {"0":"349fb63699536e3afa85","1":"bee27aca2520266dc712","2":"33b528553126c568862d","3":"fa3c6d89f814fb6957bf","4":"4a1dd197f9b7880588f7","5":"4d43bdfbbbfe550e90bf","6":"1b4a5081206bfe780573","7":"d370ff19cb6c2ae8ac00","8":"7b16c82808d13f382f7f","9":"63790839cf755f8a7ef5","10":"b0e2b70efdd402820bce","11":"b0a6d1af6edf5413bb9a","12":"ccfcc54ef1c4ad302e24","13":"e30e19d5697d373388fc","14":"ba792e004a437a5cbbf5","15":"4eb7de17552f80c3a81a","16":"aae9161b6cbe1f556b49","17":"435a5237c94bbe6d989f","18":"efff893826b7b7c8ae40","19":"bc1c4b56355d592484f7","20":"9eb65524282e1834862e","21":"15ce4f4860e1f25ae763","22":"9b04b9c6227eff79163c","23":"0e906e8bfcb463277f92","24":"19741ce520c80ccfa98e","25":"6ed3a12964eca82e8f91","26":"0e28f3a005e8cc71d79c","28":"ec22a727fb961bb7e42e","29":"96b06da89398d4b83765","30":"d89791ae5c0595a7125a","31":"6adee8ebd41e7dbb4b2d","32":"839003738c2a64a6f1b1","33":"3ffa9e5a41fbc2281b66","34":"bf00af5dfe95bd61d815","35":"e154665acff6693546bb","37":"0e8e3f0f8839623315a9","38":"4257f5f3d87a1aa73834","39":"84e0e6c1e56db20f54cf","40":"1beecdb92ff8899b5e43","41":"e3445361975a9ddc055b","42":"865d6f172a37567df4bd","43":"2c87c410ad9a5652d7b0","44":"0bfa0f6a8d0ae5ae28d1","45":"b6d5d3f297c772949d36","46":"6d6e9d8171f4da4f06e4","47":"fc2b8ef805e96b6c4f25","48":"6cf1a65709180c26dafe","49":"6cb98d835c4c6e526949","50":"83b629053d18bec566b6","51":"38ad5cb71dee5a121f3f","52":"0975171a31453beaf1ef","53":"331b212d6cafe38e0284","54":"6b4ce733012ef713625e","55":"63091a0101b407e30a9f","56":"64c7302d2a54e2b9c941"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"4":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"37":1,"38":1,"40":1,"41":1,"42":1,"43":1,"44":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"52":1,"55":1,"56":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendors~Accounts~Admin~AnnualReport~Calendar~Case~Cases~Client~ClientDelete~Clients~DOGCases~Discrep~4d6154d1","1":"vendors~Accounts~Admin~AnnualReport~Case~Cases~Client~ClientDelete~Clients~DOGCases~Discrepancy~Dock~55d59509","2":"vendors~Accounts~Admin~AnnualReport~Case~Cases~Client~Clients~DOGCases~Discrepancy~Dockets~DogHoldin~84f470a9","4":"Admin~IngestedFiles~IngestionPanel~IngestionTracker~LossRuns~NewsFeedManagement~Securities~Securitie~05fd6ed6","6":"Accounts","7":"Admin","8":"AnnualReport","9":"Calendar","10":"Case","11":"Cases","12":"Client","13":"ClientDelete","14":"Clients","15":"DOGCases","16":"Discrepancy","17":"Dockets","18":"DogHoldings","19":"Forbidden","20":"ForeignTrades","21":"Holdings","22":"Holdings13f","23":"HowToVideos","24":"IngestedFiles","25":"IngestionPanel","26":"IngestionTracker","28":"Login","29":"LossCalculator","30":"LossOverviewDisplay","31":"LossReport","32":"LossRuns","33":"Motions","34":"NavigationPage","35":"NewsFeedManagement","37":"ObjectDetail","38":"OktaLogin","39":"PageNotFound","40":"QuarterlyReports","41":"ReportsMain","42":"ScorecardReport","43":"Securities","44":"SecuritiesIngestion","45":"SecuritiesSquash","46":"SecurityDrops","47":"SkippedFiles","48":"StagedFiles","49":"Trades","50":"TxnSearch","51":"Updates","52":"UserProfile","53":"vendors~Calendar","54":"vendors~OktaLogin","55":"vendors~SkippedFiles"}[chunkId]||chunkId) + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/assets/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 324);
